import { render, staticRenderFns } from "./RelocationsPage.vue?vue&type=template&id=7bc44648&"
import script from "./RelocationsPage.vue?vue&type=script&lang=ts&"
export * from "./RelocationsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports